import { FC } from 'react';
import Loading from '../../../../assets/loading/loading';
import ModalComponent from '../../../modal/modal';
import styles from '../../userVerificationModal.module.css';
import { LoaderProps } from '../../userVerificationModal.types';

export const Loader: FC<LoaderProps> = (props: LoaderProps) => (
  <div className={styles.userVerificationOverlay}>
    <ModalComponent
      title=""
      open={props.show}
      onToggle={props.onToggle}
      isShowClose={true}
      noHeaderBorder
      centered
      dialogClassName="w-[clamp(400px,50%,600px)]"
    >
      <div className={`${styles.content} overflow-hidden`}>
        <Loading />
      </div>
    </ModalComponent>
  </div>
);
